import React from 'react';
import { motion } from 'framer-motion';
import { Brain, Target, ArrowRight } from 'lucide-react';
interface QuizStartScreenProps {
  onStart: () => void;
}
export function QuizStartScreen({
  onStart
}: QuizStartScreenProps) {
  return <div className="min-h-screen flex flex-col justify-center items-center px-6 bg-gradient-to-br from-gray-50 to-gray-100 relative overflow-hidden" data-id="element-287">
      <div className="absolute top-[-10%] right-[-5%] w-[60vw] h-[60vw] rounded-full bg-brand/5 blur-3xl -z-10" data-id="element-288" />
      <div className="absolute bottom-[-10%] left-[-5%] w-[40vw] h-[40vw] rounded-full bg-brand/5 blur-3xl -z-10" data-id="element-289" />

      <div className="max-w-2xl mx-auto text-center z-10" data-id="element-290">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6
      }} data-id="element-291">
          <span className="inline-block py-1.5 px-4 rounded-full bg-brand/10 text-brand text-sm font-bold tracking-widest uppercase mb-6" data-id="element-292">
            Interactive Quiz
          </span>
          <h1 className="text-4xl md:text-6xl font-black leading-tight mb-4 text-dark" data-id="element-293">
            Specialty Gap Explorer
          </h1>
          <p className="text-lg text-gray-600 mb-12 leading-relaxed max-w-xl mx-auto" data-id="element-294">
            Test your knowledge of specialty behaviors in CKD management. Open
            specialty cards and match them with their correct approaches,
            drivers, and barriers.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12 max-w-lg mx-auto" data-id="element-295">
          <div className="bg-white p-6 rounded-2xl shadow-sm border border-gray-200 flex items-start text-left" data-id="element-296">
            <Brain className="text-brand mr-4 flex-shrink-0" size={28} data-id="element-297" />
            <div data-id="element-298">
              <h3 className="font-bold text-dark mb-1" data-id="element-299">3 Rounds</h3>
              <p className="text-sm text-gray-600" data-id="element-300">
                Approach, Drivers, and Barriers
              </p>
            </div>
          </div>
          <div className="bg-white p-6 rounded-2xl shadow-sm border border-gray-200 flex items-start text-left" data-id="element-301">
            <Target className="text-brand mr-4 flex-shrink-0" size={28} data-id="element-302" />
            <div data-id="element-303">
              <h3 className="font-bold text-dark mb-1" data-id="element-304">12 Questions</h3>
              <p className="text-sm text-gray-600" data-id="element-305">
                Match traits to 4 specialties
              </p>
            </div>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} data-id="element-306">
          <button onClick={onStart} className="inline-flex items-center justify-center px-10 py-4 text-lg font-bold text-white bg-brand rounded-full hover:bg-red-700 transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105" data-id="element-307">
            Start Quiz
            <ArrowRight className="ml-2" size={20} data-id="element-308" />
          </button>
        </motion.div>
      </div>
    </div>;
}